module.exports = __webpack_public_path__ + "static/logo-marriott-international-2b79b9a83c14357c56a939c86699ef67.png";